import { gql } from "@/gql";

export const GET_DISCOUNT_ANALYTICS = gql(`
  query GetDiscountAnalytics($filters: DiscountAnalyticsFiltersInput!) {
    discountAnalyticsReport(filters: $filters) {
      reportPeriodStart
      reportPeriodEnd
      generatedAt
      scope
      salonId
      franchiseId
      isPremiumEnabled

      summary {
        totalDiscountedAppointments
        totalAppointmentsInWindow
        discountedAppointmentRate
        totalAmountDiscounted
        totalDiscountedRevenue
        totalOriginalRevenue
        averageDiscountPerAppointment
        uniqueCustomersUsingDiscount
        newCustomerShare
        averageOrderValueDiscounted
        averageOrderValueNonDiscounted
        discountCustomerLifetimeValue
        nonDiscountCustomerLifetimeValue
        lifetimeValueDelta
        discountCustomerCount
        nonDiscountCustomerCount

        dayOfWeekDistribution {
          dayOfWeek
          redemptionCount
          totalAmountDiscounted
        }
        hourOfDayDistribution {
          bucket
          redemptionCount
          totalAmountDiscounted
        }

        wastedRedemptions {
          totalCount
          totalAmountDiscounted
          declinedCount
          declinedAmount
          noShowCount
          noShowAmount
          rescheduledCount
          rescheduledAmount
        }

        inFlightRedemptions {
          totalCount
          totalAmountDiscounted
        }

        comparison {
          totalAmountDiscountedDelta
          totalDiscountedRevenueDelta
          uniqueCustomersDelta
          redemptionCountDelta
        }
      }

      campaigns {
        discountId
        discountName
        couponType
        isActive
        redemptionCount
        uniqueCustomers
        totalAmountDiscounted
        totalDiscountedRevenue
        totalOriginalRevenue
        averageDiscountPerAppointment
        newCustomerCount
        returningCustomerCount
        repeatVisitRate30d

        redemptionTrend {
          date
          redemptionCount
          amountDiscounted
        }

        serviceBreakdown {
          serviceId
          serviceName
          redemptionCount
          amountDiscounted
          originalRevenue
        }

        publicCouponState {
          code
          usageCount
          maxUsages
          exhaustionRate
        }

        wasted {
          totalCount
          totalAmountDiscounted
          declinedCount
          declinedAmount
          noShowCount
          noShowAmount
          rescheduledCount
          rescheduledAmount
        }

        inFlightCount
        inFlightAmount

        baselineRevenue
        actualRevenue
        incrementalRevenue
        cannibalizationRate
        roiConfidence
        campaignDurationDays
        baselineAppointmentCount

        haloServices {
          serviceId
          serviceName
          appointmentCount
          attachRate
          revenueAttributed
        }
        avgServicesPerAppointmentDiscounted
        avgServicesPerAppointmentBaseline
        upsellLift

        dayOfWeekDistribution {
          dayOfWeek
          redemptionCount
          totalAmountDiscounted
        }
        hourOfDayDistribution {
          bucket
          redemptionCount
          totalAmountDiscounted
        }

        funnel {
          bannerView
          bannerClick
          codeInput
          codeApplied
          codeRejected
          bookingStarted
          bookingCompleted
        }
        funnelConversionRates {
          viewToClick
          viewToApply
          applyToBookingStarted
          applyToBookingCompleted
          bookingStartedToCompleted
        }
        sourceBreakdown {
          source
          redemptionCount
          totalAmountDiscounted
          conversionRate
        }
        segmentBreakdown {
          segment
          redemptionCount
          uniqueCustomers
          totalAmountDiscounted
          averageInWindowSpend
        }
      }

      salonBreakdown {
        salonId
        salonName
        redemptionCount
        totalAmountDiscounted
        totalDiscountedRevenue
        uniqueCustomers
      }
    }
  }
`);
